// @flow
export const createAPIEndpoints = ({ JSON, Private }: Object): Object => ({
	fetch: () => JSON.get('players.json'),
	coach: () => JSON.get('coach/players.json'),
	fetch_past_year: params => JSON.get(`archive/${params.year}/players.json`),
	fetch_past_player_matches: params => JSON.get(
		`archive/${params.year}/stats/players/${params.player_id}.json`
	),
	fetch_matches: params => JSON.get(`stats/players/${params.player_id}.json`),
	fetch_all_matches: params => JSON.get(`stats/${params.round_id}.json`),
	favourites: () => Private.get('players/favourites'),
	add_to_favourites: params => Private.get('players/add_to_favourites', params),
	remove_from_favourites: params => Private.get('players/remove_from_favourites', params),
	fetch_all_stats: () => JSON.get('stats/all.json'),
	fetch_all_custom_stats: params => JSON.get(`draft/${params.league_id}/stats.json`, params),
	fetch_all_custom_coach_stats: params => 
		JSON.get(`draft/${params.league_id}/coach.json`, params),
	fetch_players_venue_stats: () => JSON.get('stats/players_venues_stats.json'),
	fetch_player_venue_stats_draft: params => 
		JSON.get(`draft/${params.league_id}/players_venues.json`),
	fetch_players_opposition_stats: () => JSON.get('stats/players_opponents_stats.json'),
	fetch_players_opposition_stats_draft: params => 
		JSON.get(`draft/${params.league_id}/players_opponents.json`),
});

export default createAPIEndpoints;


// WEBPACK FOOTER //
// ./src/utils/api/players/index.js